import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { isAdmin, checking } = useAuth();
  if (checking) {
    return (
      <div className="min-h-screen bg-[#FAF6EF] flex items-center justify-center text-brand-700">
        Checking session…
      </div>
    );
  }
  if (!isAdmin) return <Navigate to="/admin/login" replace />;
  return children;
};
